import { get } from '../shared/utils/FetchSSL.util';

export const getFiscalAnnualPreview = async (
	year: string,
	month?: string,
	tokenSession?: string,
) => {
	try {
		const response = await get(
			`/tax/fiscal-profile/declarations/annual-declarations/not-acquired/preview?year=${year}${month ? `&month=${month}` : ''}`,
			{
				token: true,
				isNewGateway: true,
				tokenSession,
			},
		);
		return response;
	} catch (error) {
		throw error;
	}
};
